import { useSelector, } from 'react-redux';
import { useEffect, } from 'react';
import { actionFetchInvoices, useAppDispatch, IReducerStore, } from '@Store';

let initiated = false;

export const useInvoices = (autoload: boolean = true) => {
  const dispatch = useAppDispatch();
  const invoices = useSelector((store: IReducerStore) => store.invoices);

  useEffect(() => {
    if (!initiated && autoload && !invoices.loaded && !invoices.loading) {
      initiated = true;
      dispatch(actionFetchInvoices());
    }
  }, [autoload, invoices.loaded, invoices.loading, dispatch, ]);

  return invoices;
};
